import $CC from 'plugins/kapida/platformConfigs/integrationMaps/cargoCompanies';
import { objectSelector } from 'theme/utils';

class CargoCompanies {
  constructor({ results }) {
    this.results = results;
  }
}

class Company {
  constructor({ id, name, shippingCompany, isActive }) {
    this.id = id;
    this.name = name;
    this.shippingCompany = shippingCompany;
    this.isActive = isActive;
  }
}

const companyMapper = (companies) => {
  return companies.map((item) => {
    return new Company({
      id: objectSelector(item, $CC.COMPANY.ID),
      name: objectSelector(item, $CC.COMPANY.NAME),
      shippingCompany: objectSelector(item, $CC.COMPANY.SHIPPING_COMPANY),
      isActive: objectSelector(item, $CC.COMPANY.IS_ACTIVE),
    });
  });
};

export const cargoCompaniesMapper = (data) => {
  return new CargoCompanies({
    results: companyMapper(objectSelector(data, $CC.PATH, [])),
  });
};



// WEBPACK FOOTER //
// ./src/models/kapidaModels/cargoCompanies.js